/**
 * Copyright Highway9 Networks Inc.
 */

import { useHistory, useLocation } from "react-router-dom";
import { useAppSelector } from "~/store/hooks";
import { edgeEdgesWithPool } from "~/store/context/edgeSlice";
import { EDGES } from "~/constants/routes";
import { updateURL } from "~/helpers/history";
import {
  notifyGoingOutOfSupportEdgeFilterTransition,
  useGoingOutOfSupportReleaseCallout,
  GOING_OUT_OF_SUPPORT_EDGE_BANNER_SUPPRESSED_KEY,
  GOING_OUT_OF_SUPPORT_EDGE_BANNER_SUPPRESSED_EDGES_KEY,
} from "~/views/edges/GoingOutOfSupportReleaseCallout";
import { WarningChip } from "./WarningChip";

export function GoingOutOfSupportChip() {
  const edges = useAppSelector(edgeEdgesWithPool);
  const { goingOutOfSupportEdges, isSuppressed } = useGoingOutOfSupportReleaseCallout(edges, {
    suppressedKey: GOING_OUT_OF_SUPPORT_EDGE_BANNER_SUPPRESSED_KEY,
    suppressedEdgesKey: GOING_OUT_OF_SUPPORT_EDGE_BANNER_SUPPRESSED_EDGES_KEY,
  });
  const history = useHistory();
  const location = useLocation();

  const handleViewAll = () => {
    if (location.pathname === EDGES) {
      updateURL({ goingOutOfSupportOnly: "true" });
      notifyGoingOutOfSupportEdgeFilterTransition();
      return;
    }
    notifyGoingOutOfSupportEdgeFilterTransition();
    history.push(`${EDGES}?goingOutOfSupportOnly=true`);
  };

  return (
    <WarningChip
      items={goingOutOfSupportEdges.map((e) => ({ id: e.id, name: e.name ?? "Unknown", secondary: e.currentRelease }))}
      visible={isSuppressed}
      label={`${goingOutOfSupportEdges.length} mobile ${goingOutOfSupportEdges.length === 1 ? "edge" : "edges"} going out of support soon`}
      header="Mobile edge release going out of support soon. Please upgrade."
      onViewAll={handleViewAll}
    />
  );
}
